import { useQuery } from 'react-query'
import { BrightNess, LightColorName, Visibility } from '../Data/Types'

export interface ApiResults {
	projectorSets: 1 | 2
	productName: string
	productSku: string
	productImageUrl: string
	visibility: Visibility
	lineLength: number
	watts: number
	lineThickness: number
	specSheetUrl: string
}

export interface ProductQueryResponse {
	imageSrc: string
	productName: string
	visibility: Visibility
}
// only send lengths in metres
export interface ProductQueryParams {
	lightColor?: LightColorName
	mountingDistance?: number
	lineLength?: number
	numLines?: number
	ambientLightingConditions?: BrightNess
}

const fetchProductSuggestions = async (
	productQueryParams: ProductQueryParams,
	disabled: boolean,
): Promise<ProductQueryResponse | undefined | Error> => {
	if (disabled) return
	const response = await fetch('https://swapi.dev/api/people/1/')

	if (response.ok) {
		return {
			visibility: 'bright',
			imageSrc: 'https://www.google.com',
			productName: 'Product Name',
		}
	} else {
		throw Error('Error fetching product suggestions')
	}
}
const useProductSuggestions = (
	productQueryParams: ProductQueryParams,
	disabled: boolean,
) => {
	const { isLoading, isError, data, error } = useQuery<
		ProductQueryResponse | undefined | Error,
		Error
	>(
		[disabled, productQueryParams],
		() => fetchProductSuggestions(productQueryParams, disabled),
		{ staleTime: Infinity, cacheTime: Infinity },
	)
	return {}
}

export default useProductSuggestions
